__webpack_require__.p = "/ui-resources/";